import { render, staticRenderFns } from "./feedback.component.vue?vue&type=template&id=36cea3f8"
import script from "./feedback.component.vue?vue&type=script&lang=js"
export * from "./feedback.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports